import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FollowItem } from 'src/app/core/interfaces/user.model';
import { AccountService } from 'src/app/core/services/account.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-follow',
  templateUrl: './modal-follow.component.html',
  styleUrls: ['./modal-follow.component.css']
})
export class ModalFollowComponent implements OnInit {

  @Input() list: number[];
  @Output() onClose = new EventEmitter<any>();

  constructor(private accountService: AccountService,) { }

  ngOnInit(): void {
  }

  close() {
    this.onClose.emit();
  }

}
